import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    ERR_MSG, REF_TOK_SUC_200,
    RESET_PASS_USERNAME_ERR,
    RESET_PASSWORD_101,
    RESET_PASSWORD_102,
    RESET_PASSWORD_103, RESET_PASSWORD_104, RESET_PASSWORD_105,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES,

} from "../constants/constants";
import {LOGOUT_URL, REFRESH_TOKEN_URL} from "../config/url-config";
import {extractStatusCode} from "../helper/responsehelper";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {resetPasswordStatus} from "./resetpasswordservice";

export const RefreshTokenService = ()=>{
    return new Promise((resolve,reject)=>{
        axiosInstance
            .get(REFRESH_TOKEN_URL())
            .then((response) => {
                let statusCode = extractStatusCode(response)
                if(statusCode === REF_TOK_SUC_200){
                    resolve(response)
                }else {
                    store.dispatch(loadSessionExpired(true))
                    reject( ERR_MSG)
                }
            })
            .catch((error) => {
                console.log(error)
                store.dispatch(loadSessionExpired(true))
                reject(ERR_MSG)
            });
    })
}